/**
 * Formats question data used for displaying question results to teachers and students.
 * @param question - The question to format
 * @param subjectId - The subject ID this question is asked in
 * @param isAdminOrCoordinator
 * @param isTeacher - Whether the current viewer is a teacher
 * @param isStudent
 * @param isStudentView
 * @param studentId
 * @param showLearningCheckpointEnhancedTab
 * @returns {{score: number, link: (string|undefined), id: *, title: string, percent: number, key: string}}
 */
const getQuestionData = (
  question,
  subjectId,
  isAdminOrCoordinator,
  isTeacher,
  isStudent,
  isStudentView,
  studentId,
  showLearningCheckpointEnhancedTab,
) => {
  const baseUrl = `/${subjectId}/aggregate/results/${question.assignmentId}`;

  return {
    percent: Math.round(question.avgScore),
    score: question.scores[0],
    title: `Q.${question.itemNumber}`,
    link: isStudent
      ? `${baseUrl}/student/questions/${question.id}#question-table`
      : (isTeacher || isAdminOrCoordinator) && isStudentView
        ? `${baseUrl}/students/${studentId}/questions/${question.id}`
        : showLearningCheckpointEnhancedTab
          ? `${baseUrl}/questions_enhanced/questions/${question.id}`
          : `${baseUrl}/questions/${question.id}`,
    key: `Q.${question.itemNumber}`,
    id: question.id,
  };
};

export default getQuestionData;
